import { Injectable } from "@nestjs/common";
import { RecruitmentActivities } from "../entity/recruitment-activities.entity";
import { RecruitmentActivitiesDTO } from "./recruitment-activities.dto";

@Injectable()
export class RecruitmentActivitesAdapter{

    public convertDtoToEntity(dto: RecruitmentActivitiesDTO, isUpdate: boolean = false): RecruitmentActivities{
        const entity = new RecruitmentActivities();
        entity.recruitmentActivityId = dto.recruitmentActivityId;
        entity.candidateName = dto.candidateName;
        entity.activity = dto.activity;
        entity.activityDate = dto.activityDate;
        entity.remarks = dto.remarks;
       entity.isActive = dto.isActive == undefined ? true : dto.isActive;
        if(isUpdate){
            entity.updatedUser = dto.updatedUser;
        }else {
            entity.isActive = true;
            entity.createdUser = dto.createdUser;
        }
        return entity;
    }

    public convertEntityToDto(entity: RecruitmentActivities): RecruitmentActivitiesDTO{
        const Dto = new RecruitmentActivitiesDTO;
        Dto.recruitmentActivityId = entity.recruitmentActivityId;
        Dto.candidateName = entity.candidateName;
        Dto.activity = entity.activity;
        Dto.activityDate = entity.activityDate;
        Dto.remarks = entity.remarks;
        Dto.isActive = entity.isActive;
        Dto.createdAt = entity.createdAt;
        Dto.createdUser = entity.createdUser;
        Dto.updatedAt = entity.updatedAt;
        Dto.updatedUser = entity.updatedUser;
        Dto.versionFlag = entity.versionFlag;
        return Dto;
    }

}